exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nbutton[data-v-7772b8b1] {\n    font-size: 1em;\n    white-space: normal;\n    word-wrap: break-word;\n    max-width: 100%;\n}\n", ""]);

// exports
